import { EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";
import * as appointmentsActions from "./calendar.actions";
import { CalendarResourceDto } from "../interfaces/calendar_resource_dto";
import { getCalendarResourcesSuccess } from './calendar.actions';

export const resourcesFeatureKey = "resources";

export interface State {
    [resourcesFeatureKey]: ResourcesState;
}

export interface ResourcesState extends EntityAdapter<CalendarResourceDto> {
}

export const adapter = createEntityAdapter<CalendarResourceDto>({
    selectId: (calendarResource: CalendarResourceDto) => String(calendarResource.calendar_resource_id) || "",
    sortComparer: false,
});

export const initialState = adapter.getInitialState({
});

const resourcesReducer = createReducer(
    initialState,
    on(appointmentsActions.addCalendarResourcesSuccess,
        (state, { resources }) => adapter.setAll(resources, state),
    ),
    on(appointmentsActions.getCalendarResourcesSuccess,
        (state, { resources }) => adapter.setAll(resources, state),
    ),
    on(appointmentsActions.updateCalendarResourceSuccess,
        (state, { resource }) => adapter.updateOne({ id: String(resource.calendar_resource_id), changes: resource }, state),
    ),
);

export function resourceReducer(
    state: any,
    action: Action,
) {
    return resourcesReducer(state, action);
}
